import React, { FC, useState } from "react";

import { redirectToAirflowGraphUrl } from "api/ScheduledTasksApi";
import airflowLogo from "img/airflow-icon16.png";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { T } from "services/lang/LanguageService";
import { AirflowDag } from "types/airflow";
import AirflowDagForm from "./AirflowDagForm";
import AirflowTaskForm from "./AirflowTaskForm";

type DagHeaderProps = {
  dag: AirflowDag;
};
const DagHeader: FC<DagHeaderProps> = ({ dag }) => {
  const [createTaskDialog, setCreateTaskDialog] = useState(false);
  const [editDagDialog, setEditDagDialog] = useState(false);

  return (
    <div className="flex justify-content-between px-3 py-2">
      <div className="flex gap-2">
        <Button
          label={T("action.create-task")}
          icon="pi pi-plus"
          className="p-button-sm"
          onClick={() => setCreateTaskDialog(true)}
        />
        <Button
          label={`${T("action.edit")} DAG`}
          icon="pi pi-pencil"
          className="p-button-sm"
          onClick={() => setEditDagDialog(true)}
        />
      </div>
      <div>
        <a href={redirectToAirflowGraphUrl(dag?.dagId)} target="_blank" rel="noreferrer">
          <Button
            label={`Airflow DAG ${T("word.graph")}`}
            type="button"
            icon={<img src={airflowLogo} alt="" className="mr-2" />}
            className="p-button-sm p-button-outlined"
            severity="contrast"
          />
        </a>
      </div>
      <Dialog
        visible={createTaskDialog}
        header="Create new task"
        onHide={() => setCreateTaskDialog(false)}
        style={{ width: "min(100%, 700px)" }}
      >
        <AirflowTaskForm closeDialog={() => setCreateTaskDialog(false)} dag={dag} />
      </Dialog>

      <Dialog
        visible={editDagDialog}
        header="Edit DAG"
        onHide={() => setEditDagDialog(false)}
        style={{ width: "min(100%, 700px)" }}
      >
        <AirflowDagForm closeDialog={() => setEditDagDialog(false)} dag={dag} />
      </Dialog>
    </div>
  );
};

export default DagHeader;
